module.exports = {"id":"216102","name":"André Claro","rating":"71","photo":"./data/images/photos/2/216102.png","club":{"name":"Estoril Praia","logo":"./data/images/clubs/EstorilPraia.png"},"positions":["AG","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreClaro0.json
// module id = 336
// module chunks = 0